/*eslint-disable */
import React, { useEffect, useState } from "react";
import { Button, Modal, Form as FormUi, Icon } from "semantic-ui-react";
import { withFormik, Field as Fieldmik,Form as Formiker } from "formik";
import * as yup from "yup";
import CreatAxios from "../axiosComponent/create";
import { ERROR_MESSAGES, REQUIRED_FIELDS, INVALID_FIELDS } from "../../utils/validationConstant";
import cogoToast from "cogo-toast";
import { MESSAGES } from "../../views/masters/skuType/skuTypeConstants";
import MyCity from "../apiInputs/myCity";
import { MyInput } from "../dynamicComponent/myInputs";
import { AllRegex } from "../../utils/validation";
import {add_pincode_modal, buttons} from './driverConstants'

function AddPincode({ handleSubmit, t, touched, errors, values,setFieldValue, ...props }) {
    useEffect(()=>{
        clearFieldValues()
        },[props.open])
    const clearFieldValues = ()=>{
        setFieldValue("pincode","")
        setFieldValue("cityId","")
    }
  return (
    <Modal
      onClose={() => props.handleClose}
      onOpen={() => props.handleOpen}
      open={props.open}
      size="small"
      trigger={
        <Button icon type="button" onClick={props.handleOpen}>
          <Icon name="plus" />
        </Button>
      }
    >
      <Modal.Header>
        {add_pincode_modal.title||"Add New Pincode"}
      </Modal.Header>
      <Modal.Content>
        <Modal.Description>
        <Formiker>
            <div className="ui form">
          <FormUi.Group>
            <FormUi.Field width={2}>
              <label className="labelName">
                {add_pincode_modal.pincode.title || "Pincode"}{" "}<span className="red"> *</span>
              </label>
            </FormUi.Field>
            <FormUi.Field
              width={4}
              error={touched.pincode && errors.pincode ? true : false}
            >
              <Fieldmik
                type="text"
                //className="ui input"
                name="pincode"
                component={MyInput}
                placeholder={
                  add_pincode_modal.pincode.placeholder||"Enter Pincode"
                }
              />
              {touched.pincode && errors.pincode ? (
                <div className="error-msg">
                  {errors.pincode}
                </div>
              ) : null}
            </FormUi.Field>
            
            <FormUi.Field width={2}></FormUi.Field>
            <FormUi.Field width={2}>
              <label className="labelName">
                {add_pincode_modal.city.title||"City"}
              </label>
            </FormUi.Field>
            <FormUi.Field
              width={4}
              error={touched.cityId && errors.cityId ? true : false}
            >
              <Fieldmik
                type="text"
                //className="ui input"
                name="cityId"
                component={MyCity}
                placeholder={
                  add_pincode_modal.city.placeholder||"Select city"
                }
              />
              {touched.cityId && errors.cityId ? (
                <div className="error-msg">
                  {errors.cityId}
                </div>
              ) : null}
            </FormUi.Field>
            </FormUi.Group>
          </div>
          </Formiker>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button type="button" onClick={props.handleClose}>
          {buttons.cancel||"Cancel"}
        </Button>
        <Button color="blue" type="submit" onClick={handleSubmit}>
          {buttons.submit||"Submit"}
        </Button>
        
      </Modal.Actions>
    </Modal>
  );
}

const FormikAddPincode = withFormik({
  validationSchema: yup.object({
    pincode : yup.string().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).matches(AllRegex.Pincode, INVALID_FIELDS.INVALID_PINCODE).nullable(),
    cityId : yup.number().required(REQUIRED_FIELDS.FIELD_IS_REQUIRED).nullable(),
  }),
  mapPropsToValues: (props) => {
    return {
        pincode: "",
        cityId: ""
    };
  },
  handleSubmit(values, { props, setFieldValue }) {
    CreatAxios({
      url: `pincode`,
      payload: {
        ...values,
      },
    })
      .then((res) => {
        if(res.data.status===200){
            cogoToast.success(res.data?.message, { position: 'top-right' })
            setTimeout(()=>{
                props.handleClose()
                props.updatePincodeData()
            },1000)
        }else{
            cogoToast.error(res.data?.message, { position: 'top-right' })
        }
      })
      .catch((err) => {
        cogoToast.error(err.data?.message, { position: 'top-right' })
        console.log(err)
      });
  },
})(AddPincode);

export default FormikAddPincode ;
